import { Flex, Text } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

interface IProps {
  aspectRatio?: string;
  backgroundColor?: string;
  children: ReactNode;
}

// children expected to be something text-like
export const VideoPlaceholder = (props: IProps) => {
  return (
    <Flex
      style={{
        borderRadius: 'var(--radius-4)',
        aspectRatio: props.aspectRatio ?? '1.6',
        backgroundColor: props.backgroundColor ?? 'var(--gray-6)',
      }}
      align="center"
      justify="center"
    >
      <Text size="6" color={RADIX.COLOR.SECONDARY}>
        {props.children}
      </Text>
    </Flex>
  );
};
